var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('article', {
    staticClass: "generic-faq position-relative pt-4 pb-2 pr-3",
    class: {
      open: _vm.open
    }
  }, [_c('div', {
    staticClass: "title-faq"
  }, [_c('h2', {
    staticClass: "question font-weight-normal mb-3",
    domProps: {
      "textContent": _vm._s(_vm.question)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button position-absolute d-block",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('simple-paragraph', {
    ref: "answer",
    staticClass: "answer overflow-hidden",
    style: {
      'max-height': _vm.faqHeight
    },
    attrs: {
      "paragraph": _vm.answer
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };